import $ from 'jquery'
import Backbone from 'backbone'
import template from './calendar-form.hbs'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import enums from 'scoreboard/components/enums'
import calendars from 'scoreboard/components/calendars'
import dropdown from 'scoreboard/components/dropdown'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import integerValidator from 'scoreboard/components/validators/integer-validator'
import positiveIntegerValidator from 'scoreboard/components/validators/positive-integer-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import config from 'scoreboard/components/config'
import FormView from 'scoreboard/components/form-view'
import select from 'scoreboard-select'
import permissions from 'scoreboard/components/permissions'
import licenseRestriction from 'scoreboard/components/license-restriction'
import appDisplay from 'scoreboard/components/app-display'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import calendarNameValidator from 'scoreboard/admin/calendars/calendar-name-validator'

// sort order for standard calendars
var sortOrder = {
	'daily': 0,
	'weekly': 1,
	'monthly': 2,
	'quarterly': 3,
	'yearly': 4,
	'fiscal-quarterly': 5,
	'fiscal-yearly': 6
}

var CalendarForm = Backbone.View.extend({

	// this.calendar is a plain javascript object representing the calendar

	tagName: 'form',
	className: 'calendar-form',

	events: {
		'change [name=type]': 'onChangeType'
	},

	initialize: function(options) {
		this._markedFields = []
		this.options = options
		this.calendar = options.calendar
	},

	render: function() {
		this.$el.empty().append(template(this.calendar))

		let calOptions = [{
			value: 'standard',
			label: 'admin.calendar.standard'
		}, {
			value: 'custom',
			label: 'admin.calendar.custom'
		}]

		// #18523 don't allow new standard calendars on high side
		if (config.replicationInputEnabled && _.isNil(this.calendar.id) && !permissions.serverAdmin()) {
			calOptions = calOptions.slice(1)
			this.calendar.type = 'custom'
		}

		this._toggle = new LabeledToggle({
			value: this.calendar.type === 'custom' ? 'custom' : 'standard',
			options: calOptions
		})

		this.$('.type-toggle').append(this._toggle.el)
		this._toggle.render()
		this._toggle.on('change', function() {
			this._toggleFields()
			this._change()
			this.$('.banner.banner-error').addClass('is-not-displayed')
		}.bind(this))

		// #52493 only add calendarValidator to label field when creating a new calendar
		let labelValidators = [requiredValidator]
		if (_.isNil(this.calendar.id)) {
			labelValidators.push(calendarNameValidator)
		}
		this._markedFields.push(new MarkedField({
			el: this.$('[name=label]'),
			validators: labelValidators
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=daysUntilValueUpdatesLocked]'),
			markerContent: i18n.get('login.license.days'),
			validator: positiveIntegerValidator,
			evaluator: numericEvaluator
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=daysUntilNoteUpdatesLocked]'),
			markerContent: i18n.get('login.license.days'),
			validator: integerValidator,
			evaluator: numericEvaluator
		}).render())
		// #46517 prevent creating standard calendar with same name as existing
		// custom calendar
		// #51665 validate the selected label, not the value of the select
		this._markedFields.push(new MarkedField({
			el: this.$('[name=type]'),
			validator: calendarNameValidator,
			evaluator: val => this.$('[name=type] option:selected').text()
		}).render())

		let MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this._formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		}).start()
		this._formView.on('change', this._change.bind(this))
		this._busyButton = this._formView.primaryButton

		this._toggleFields()
		select(this.el.querySelectorAll('select'))
		return this
	},

	// hides or shows fields based on the current state of the form
	_toggleFields: function() {
		// if this is an existing calendar
		if (this.calendar.id) {
			this.$('.type-toggle').toggleClass('is-not-displayed', true)
		}

		// if this is an existing calendar or a custom calendar
		if (this.calendar.id || this._toggle.val() === 'custom') {
			this.$('.label').toggleClass('is-not-displayed', false)
			this.$('.standard-type').toggleClass('is-not-displayed', true)
			this.$el.removeClass('calendars-exist')
			// prevent safari from showing immediate error for empty label upon toggle
			this.$('[name=label]').data('view').clearError()
		} else {
			this.$('.label').toggleClass('is-not-displayed', true)
			this.$('[name=label]').data('view').removeTooltip()

			var availableStandardTypes = this._availableStandardTypes()
			// if there are no standard calendars left to be added
			if (_.isEmpty(availableStandardTypes)) {
				this.$el.addClass('calendars-exist')
				this.$('.standard-type').toggleClass('is-not-displayed', false)
			// if there are still standard calendars to be added
			} else {
				var typeDropdown = this.$('[name=type]').empty()
				dropdown.idLabels(typeDropdown, availableStandardTypes)
				if (!typeDropdown.val()) {
					typeDropdown.prop('selectedIndex', 0).change()
				}
				this.$el.removeClass('calendars-exist')
				this.$('.standard-type').toggleClass('is-not-displayed', false)
				typeDropdown.change()
			}
		}
	},

	// returns the enums.calendarType as an array of ids and labels filtered to
	// only show the standard calendar types that haven't already been created
	_availableStandardTypes: function() {
		var existingStandardTypes = _.transform(calendars.calendars, function(result, calendar) {
			result[calendar.type] = true
		}, {})
		var availableStandardTypes = _.pickBy(enums.calendarType, function(messageCode, typeName) {
			var allow = !existingStandardTypes[typeName]

			if (typeName === 'custom') {
				allow = false
			}
			return allow
		})
		var array = _.map(availableStandardTypes, function(messageCode, typeName) {
			return { id: typeName, label: messageCode }
		})
		return _.sortBy(array, function(type) {
			return sortOrder[type.id]
		})
	},

	onChangeType: function() {
		// use validate() instead of clearErrors() - it will clear any errors
		// but preserve any valid validation messages
		this._formView.validate()
	},

	// triggered when the user toggles between standard and custom calendar type
	_change: function() {
		if (this._toggle.val() === 'standard') {
			if (!this.calendar.id) {
				var allStandardExist = _.isEmpty(this._availableStandardTypes())
				this._busyButton.toggle(!allStandardExist)
			}
		} else {
			// disable add button if we have fields that need attention
			// upon toggling to custom calendar
			// #51670 use formView validate() to handle this correctly - it will
			// clear any previous errors and handle toggling the busy button
			this._formView.validate()
		}
	},

	test: function() {
		// #52493 for existing calendars, validate that the name has not been
		// edited to that of an existing calendar
		if (this.calendar.id) {
			let currentLabel = this.$('input[name=label]').val()
			if (this.calendar.label !== currentLabel) {
				return calendarNameValidator(currentLabel)
			}
		}

		return FormView.prototype.test.apply(this, arguments)
	},

	submit: function(e) {
		e.preventDefault()
		// #44189 if creating a new calendar, open a confirm prompt to warn
		// user that this will trigger a full score recalc
		// #49123 only a standard calendar needs score recalc warning
		if (_.isNil(this.calendar.id) && this._toggle.val() === 'standard') {
			let recalcPrompt = new ConfirmPrompt({
				titleKey: 'admin.recalcScores',
				messageKey: 'admin.recalcScoresConfirm',
				confirmLabel: 'admin.recalcScores.recalculate',
				cancelLabel: 'common.cancel',
				onConfirm: () => {
					this._submit()
				}
			})
			recalcPrompt.once('cancel', () => this.trigger('close'))
			appDisplay.dialog(recalcPrompt)
		} else {
			this._submit()
		}
	},

	_submit: function() {
		var label = this.$('[name=label]').is(':visible') ? this.$('[name=label]').val() : this.$('[name=type] option:selected').text()
		var type = this._toggle.val() == 'custom' ? 'custom' : this.$('[name=type]').val()
		var data = {
			label: label,
			type: type,
			daysUntilValueUpdatesLocked: this.$('[name=daysUntilValueUpdatesLocked]').val(),
			daysUntilNoteUpdatesLocked: this.$('[name=daysUntilNoteUpdatesLocked]').val()
		}

		$.ajax({
			method: this.calendar.id ? 'patch' : 'post',
			url: 'api/admin/calendars' + (this.calendar.id ? '/' + this.calendar.id : ''),
			data: JSON.stringify(data),
			success: function(result) {
				if (result.isYtdCalendar) {
					config.update({ ytdCalendarId: result.id })
				}
				calendars.save(_.extend(this.calendar, data, result))
				this.trigger('done', this.calendar)
			}.bind(this),
			error: function(xhr) {
				if (xhr.responseJSON.messageCode == 'admin.licenses.error.dailyCalendar') {
					appDisplay.dialog(licenseRestriction.dailyCalendarRestriction())
					this._formView.start()
				} else {
					this._formView.error(xhr)
				}
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._toggle, this._formView, this._busyButton], 'remove')
		_.invokeMap(this._markedFields, 'remove')
	}

})

export default CalendarForm

CalendarForm.__filename__ = 'admin/calendars/calendar-form.js'
